import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PageHeader = ({ title, subtitle, crumb }) => (
  <section className="relative bg-[color:var(--mv-navy)] text-white overflow-hidden">
    <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)', backgroundSize: '18px 18px' }} />
    <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-[color:var(--mv-orange)]/20 blur-3xl" />
    <div className="container-xl py-20 md:py-24 relative">
      <div className="flex items-center gap-2 text-sm text-white/70">
        <Link to="/" className="hover:text-white">Home</Link>
        <ChevronRight className="w-4 h-4" />
        <span className="text-white">{crumb}</span>
      </div>
      <h1 className="font-display text-5xl md:text-6xl font-extrabold mt-3 tracking-tight">{title}</h1>
      {subtitle && <p className="mt-4 text-white/75 max-w-2xl text-lg">{subtitle}</p>}
    </div>
  </section>
);

export default PageHeader;
